import { apiUrl } from '../config/api';

export async function submitUserFormPdf({
  email,
  fileName,
  pdfBlob,
  formIndex,
  siteProject,
  supervisorName,
  year,
  month,
}) {
  const formData = new FormData();
  formData.append('form_name', fileName);
  formData.append('file', pdfBlob, fileName);
  if (formIndex != null) formData.append('form_index', String(formIndex));
  if (siteProject) formData.append('site_project', siteProject);
  if (supervisorName) formData.append('supervisor_name', supervisorName);
  if (year != null) formData.append('year', String(year));
  if (month != null) formData.append('month', String(month));

  const res = await fetch(apiUrl('/api/users/forms/submit'), {
    method: 'POST',
    headers: { 'X-User-Email': email },
    body: formData,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data.detail;
    const message = typeof detail === 'string' ? detail : data.message;
    throw new Error(message || `Submit failed (${res.status})`);
  }
  return data;
}
